import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { EmailInviteTypeDto } from "../../../autogen/bff-api";
import { useQueryParams } from "../../../common/useQueryParams";
import { ContributingEntityEmailInvite } from "./ContributingEntityEmailInvite";
import { MarketDialogueEmailInvite } from "./MarketDialogueEmailInvite";
import { OrgUserEmailInvite } from "./OrgUserEmailInvite";
import { SourcingEventEmailInvite } from "./SourcingEventEmailInvite";
import { SupplierEmailInvite } from "./SupplierEmailInvite";

export const EmailInvite = () => {
  const { t } = useTranslation();
  const { emailInviteId } = useParams();
  const params = useQueryParams();
  const secret = params.get("secret");
  const rawType = params.get("type");
  const type = parseType(rawType);
  if (!emailInviteId || !secret || !type) {
    return <div>{t("Invalid invite params!")}</div>;
  }

  switch (type) {
    case EmailInviteTypeDto.SourcingEvent:
      return <SourcingEventEmailInvite inviteId={emailInviteId} secret={secret} />;
    case EmailInviteTypeDto.Supplier:
      return <SupplierEmailInvite inviteId={emailInviteId} secret={secret} />;
    case EmailInviteTypeDto.OrgUser:
      return <OrgUserEmailInvite inviteId={emailInviteId} secret={secret} />;
    case EmailInviteTypeDto.ContributingEntity:
      return <ContributingEntityEmailInvite inviteId={emailInviteId} secret={secret} />;
    case EmailInviteTypeDto.MarketDialogue:
      return <MarketDialogueEmailInvite inviteId={emailInviteId} secret={secret} />;
  }
};

const parseType = (type: string | null): EmailInviteTypeDto | null =>
  type !== null && type in EmailInviteTypeDto ? EmailInviteTypeDto[type as keyof typeof EmailInviteTypeDto] : null;
